export const appDemoDe = {
  "AppDemo.ownShift": "eigene Schicht",
  "AppDemo.title": "Demo-Daten",
  "AppDemo.publicHint": "Demo-Daten sind öffentlich abrufbar. Verwende ausschließlich fiktive Angaben.",
  "AppDemo.relativeDates": "Datumsabstände bleiben relativ zu heute; Zahlungen entstehen aus den Verträgen, die letzte Position kann offen bleiben.",
  "AppDemo.day": "Datum",
  "AppDemo.startDay": "Beginndatum",
  "AppDemo.endDay": "Enddatum",
  "AppDemo.Cycle interval": "Intervall",
  "AppDemo.Payment cycle": "Zahlungsrhythmus",
  "AppDemo.opensAt": "geöffnet ab",
  "AppDemo.closesAt": "geöffnet bis",
  "AppDemo.allowRestPeriod": "Ruhezeit erlauben",
  "AppDemo.showOpenItem": "als fälligen Beitrag anzeigen",
  "AppDemo.invalidData": "Demo-Daten prüfen: Pflichtfelder, Zeiträume und Standortzuordnungen.",
  "AppDemo.Name": "Bezeichnung",
  "AppDemo.Studio": "Standort",
  "AppDemo.Street": "Straße",
  "AppDemo.Postal code": "Postleitzahl",
  "AppDemo.City": "Ort",
  "AppDemo.Amount": "Betrag",
  "AppDemo.Plan": "Tarif",
  "AppDemo.Trainer": "Trainer",
  "AppDemo.Start time": "Beginn",
  "AppDemo.End time": "Ende",
  "AppDemo.Duration (minutes)": "Dauer (Minuten)",
  "AppDemo.Capacity": "Kapazität",
  "AppDemo.Balance": "Punktestand",
  "AppDemo.Studios": "Standorte",
  "AppDemo.Contracts": "Verträge",
  "AppDemo.Appointments": "Termine",
  "AppDemo.Wallets": "Wertekonten",
  "AppDemo.Payments": "Zahlungen",
  "AppDemo.Check-in history": "Besuche",
  "AppDemo.Rest periods": "Ruhezeiten",
  "AppDemo.Staff schedule": "Dienstplan",
  "AppDemo.Employee": "Mitarbeiter",
  "AppDemo.Activity": "Tätigkeit",
  "AppDemo.Profile": "Profil",
  "AppDemo.First name": "Vorname",
  "AppDemo.Last name": "Nachname",
  "AppDemo.Email": "E-Mail",
  "AppDemo.Phone": "Telefon",
  "AppDemo.Mobile": "Mobiltelefon",
  "AppDemo.Add": "hinzufügen",
  "AppDemo.Remove": "entfernen"
};

export const appDemoEn = {
  "AppDemo.ownShift": "Own shift",
  "AppDemo.title": "Demo data",
  "AppDemo.publicHint": "Demo data is publicly accessible. Use fictional details only.",
  "AppDemo.relativeDates": "Dates remain relative to today; payments follow the contracts, and the latest item can remain unpaid.",
  "AppDemo.day": "Date",
  "AppDemo.startDay": "Start date",
  "AppDemo.endDay": "End date",
  "AppDemo.Cycle interval": "Interval",
  "AppDemo.Payment cycle": "Payment cycle",
  "AppDemo.opensAt": "Opens at",
  "AppDemo.closesAt": "Closes at",
  "AppDemo.allowRestPeriod": "Allow membership freeze",
  "AppDemo.showOpenItem": "Show as due contribution",
  "AppDemo.invalidData": "Check demo data: required fields, date ranges and studio assignments.",
  "AppDemo.Name": "Name",
  "AppDemo.Studio": "Studio",
  "AppDemo.Street": "Street",
  "AppDemo.Postal code": "Postal code",
  "AppDemo.City": "City",
  "AppDemo.Amount": "Amount",
  "AppDemo.Plan": "Plan",
  "AppDemo.Trainer": "Trainer",
  "AppDemo.Start time": "Start time",
  "AppDemo.End time": "End time",
  "AppDemo.Duration (minutes)": "Duration (minutes)",
  "AppDemo.Capacity": "Capacity",
  "AppDemo.Balance": "Balance",
  "AppDemo.Studios": "Studios",
  "AppDemo.Contracts": "Contracts",
  "AppDemo.Appointments": "Appointments",
  "AppDemo.Wallets": "Wallets",
  "AppDemo.Payments": "Payments",
  "AppDemo.Check-in history": "Check-in history",
  "AppDemo.Rest periods": "Rest periods",
  "AppDemo.Staff schedule": "Staff schedule",
  "AppDemo.Employee": "Employee",
  "AppDemo.Activity": "Activity",
  "AppDemo.Profile": "Profile",
  "AppDemo.First name": "First name",
  "AppDemo.Last name": "Last name",
  "AppDemo.Email": "Email",
  "AppDemo.Phone": "Phone",
  "AppDemo.Mobile": "Mobile",
  "AppDemo.Add": "Add",
  "AppDemo.Remove": "Remove"
};
